<template>
  <page layout="tabbed">
    <page-header-new
      :title="$t('ApplicationList_Title')"
      :breadcrumbs="breadcrumbs"
    >
      <template slot="actions">
        <el-button
          v-if="$route.name === 'ApplicationsList'"
          class="btn-connect btn-custom-icon"
          type="primary"
          @click="handleConnect"
          data-qa="connect-button"
        >
          <icon class="icon" glyph="app-lightning" style="margin-right: 12px" />
          {{ $t('ApplicationList_Button_Connect') }}
        </el-button>
        <el-button
          v-if="$route.name === 'ApplicationDevTeam'"
          class="btn-connect btn-custom-icon"
          type="primary"
          @click="handleSaveDeveloper"
          data-qa="save-developer-button"
        >
          <icon class="icon" glyph="save" style="margin-right: 12px" />
          {{ $t('ApplicationList_Button_SaveDeveloper') }}
        </el-button>
      </template>
    </page-header-new>
    <page-tabs :tabs="availableTabs" />
  </page>
</template>
<script>
import Page from '@/common/components/page/Page'
import PageHeaderNew from '@/common/components/page/PageHeaderNew'
import PageTabs from '@/common/components/page/PageTabs'
import { projectRoute } from '@/core/helpers'
import { EventBus } from '@/core/EventBus'

export default {
  name: 'ApplicationSitesPage',

  components: {
    Page,
    PageHeaderNew,
    PageTabs
  },

  computed: {
    availableTabs() {
      const tabs = [
        {
          title: this.$t('ApplicationList_Connections'),
          route: projectRoute({ name: 'ApplicationsList' })
        }
      ]

      if (this.$store.state.app.features.openLiveActivities) {
        tabs.push({
          title: this.$t('ApplicationList_DevTeam'),
          route: projectRoute({ name: 'ApplicationDevTeam' })
        })
      }
      return tabs
    },
    breadcrumbs() {
      return [
        {
          label: this.$t('Settings_Breadcrumb_Settings')
        },
        {
          label: this.$t('ApplicationList_Title')
        }
      ]
    }
  },

  methods: {
    handleConnect() {
      EventBus.$emit('handleConnect')
    },
    handleSaveDeveloper() {
      EventBus.$emit('handleSaveDeveloper')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/account/pages/ApplicationSitesPage.vue